import * as React from "react";
import { useState, useCallback, useMemo } from "react";
import styled from "styled-components";
import { IconButton } from "components/common";
import { Input, Button } from "components/bootstrap";
const ResetPasswordButton = styled(Button)`
  margin-top: 25px;
`;
const FlexLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const StyledIconButton = styled(IconButton)`
  color: ${({ theme }) => theme.colors.input.placeholder};
  font-size: 0.9rem;
  height: auto;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: transparent;
  }
`;
const InputWrapper = styled.div`
  width: ${({ $width }) => $width || "70%"} !important;
  flex-shrink: 0;
`;
const PasswordInput = ({
  name,
  label,
  value,
  onChange,
  onResetPassword,
  onCancelReset,
  onBlur = () => {
  },
  action = "new",
  help = void 0,
  error = void 0,
  placeholder = void 0,
  disabled = false,
  hasPassword = false,
  bsStyle,
  required = false
}) => {
  const [resetPassword, setResetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState("password");
  const togglePassword = useCallback(() => {
    setShowPassword(showPassword === "password" ? "text" : "password");
  }, [showPassword]);
  const handleResetPassword = (e) => {
    setResetPassword(true);
    onResetPassword(e);
  };
  const cancelReset = (e) => {
    setResetPassword(false);
    onCancelReset(e);
  };
  const PasswordLabelWithToggle = useMemo(
    () => /* @__PURE__ */ React.createElement(FlexLabel, null, label, /* @__PURE__ */ React.createElement(
      StyledIconButton,
      {
        title: "Toggle visibility",
        name: showPassword === "text" ? "visibility_off" : "visibility",
        onClick: togglePassword,
        ...{ size: "sm" }
      }
    )),
    [label, showPassword, togglePassword]
  );
  if (action === "edit" && !resetPassword || disabled) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, hasPassword && /* @__PURE__ */ React.createElement(InputWrapper, null, /* @__PURE__ */ React.createElement(Input, { label, id: name, "data-testid": name, type: "password", help, disabled: true, value: "********" })), !disabled && /* @__PURE__ */ React.createElement(ResetPasswordButton, { bsStyle: "default", onClick: handleResetPassword }, hasPassword ? "Reset Value" : "New Secret Value"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputWrapper, { $width: resetPassword ? "70%" : "100%" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      label: PasswordLabelWithToggle,
      name,
      "data-testid": name,
      type: showPassword,
      id: name,
      placeholder,
      value,
      help,
      error,
      bsStyle,
      required,
      onChange,
      onBlur,
      disabled
    }
  )), resetPassword && /* @__PURE__ */ React.createElement(ResetPasswordButton, { bsStyle: "default", onClick: cancelReset }, "Cancel"));
};
export default PasswordInput;
